import type { LineItemForm } from '../../../pages/Campaigns/Form/types';
import { hasSpecificTargetingApplied } from './getAppliedTargetingCategories';

export const hasPremiumContentTargeting = (values: LineItemForm): boolean => hasSpecificTargetingApplied(values);
